<div class="body">
    <!-- HEADER -->
    <app-header class="header"></app-header>
    <!-- HEADER IN MOBILE -->
    <app-header-in-section section="Listado de contrapartidas"></app-header-in-section>
    <!-- TITLE IN HEADER -->
    <h2 class="title">Listado de contrapartidas</h2>
    <!-- CONTENT OF THE EXCGANGE BOARD -->
    <app-body-exchange-list></app-body-exchange-list>

    <app-menu class="menu"></app-menu>
    <app-menu-footer></app-menu-footer>
</div>